import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19.576 14.013 9.334 22.45v9.104a.889.889 0 0 0 .889.889l6.225-.016a.889.889 0 0 0 .884-.89V26.22a.889.889 0 0 1 .889-.889h3.555a.889.889 0 0 1 .889.889v5.313a.889.889 0 0 0 .889.892l6.223.017a.889.889 0 0 0 .888-.89v-9.11l-10.24-8.429a.677.677 0 0 0-.85 0Zm16.178 5.734L21.692 8.166a2.666 2.666 0 0 0-3.388 0L4.242 19.746a.666.666 0 0 0-.089.94l1.417 1.721a.666.666 0 0 0 .939.091l13.067-10.763a.677.677 0 0 1 .85 0l13.067 10.763a.667.667 0 0 0 .939-.089l1.416-1.722a.664.664 0 0 0-.094-.94Z" })
});
export default SvgHome;
